import "./CoreValues.css";
import "./CoreValuesResponsive.css";

import corevalues from "../../../assets/data/core-values/core-values.json";
import CoreValueItem from "../../../widgets/core-value-item/CoreValueItem";

function CoreValues() {
  return (
    <div className="core-values">
      <div className="core-values-overlay"></div>
      <div className="core-values-header">
        <h1>Our Core Coorporative Values</h1>
      </div>
      <div className="core-values-summary">
        <p>
          At the heart of everything we do are the values that guide our mission
          and shape every customer experience. These principles drive our
          commitment to quality, sustainability, and meaningful impact—from our
          farms to your table.
        </p>
      </div>
      <div className="core-values-list">
        <div className="row m-0 p-sm-4 d-flex justify-content-center">
          {corevalues?.map((item, index) => {
            return <CoreValueItem item={item} key={index} />;
          })}
        </div>
      </div>
    </div>
  );
}

export default CoreValues;
